const { fr } = require('../FR/frenchInfo')
const { en } = require('../EN/englishInfo')

const currentLanguages = [en, fr]

exports.currentLanguages = currentLanguages
